import React from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { RoleSwitcher } from '../demo/RoleSwitcher';
type Step = {
  id: number;
  name: string;
  component: React.ReactNode;
};
interface LayoutProps {
  children: React.ReactNode;
  currentStep: number;
  setCurrentStep: (step: number) => void;
  steps: Step[];
  selectedDashboard: string;
  setSelectedDashboard: (dashboard: string) => void;
}
export function Layout({
  children,
  currentStep,
  setCurrentStep,
  steps,
  selectedDashboard,
  setSelectedDashboard
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-2170">
      <Header data-id="element-2171" />
      <div className="flex flex-1" data-id="element-2172">
        <Sidebar steps={steps} currentStep={currentStep} setCurrentStep={setCurrentStep} selectedDashboard={selectedDashboard} setSelectedDashboard={setSelectedDashboard} data-id="element-2173" />
        <main className="flex-1 p-8 bg-neutral-50" data-id="element-2174">
          {/* Role Switcher - Demo Mode */}
          <div className="mb-6 flex justify-end" data-id="element-2175">
            <RoleSwitcher data-id="element-2176" />
          </div>
          {children}
        </main>
      </div>
    </div>;
}